import { Checkmark } from '@carbon/icons-react';
import { useTheme } from '@repo/theme';
import { HorizBox, Pad } from 'component/basics';
import { UtilityText } from 'component/text';
import { t } from 'util/stdtypes';

type CharacterCounterProps = {
    max: number;
    min?: number;
    text: string;
};

export function CharacterCounter({ max, min, text }: CharacterCounterProps) {
    const { colors } = useTheme();
    const count = text?.length ?? 0;

    if (min === undefined) {
        if (count > max) {
            return (
                <UtilityText
                    color={colors.colorTextWarning}
                    formatParams={{ count, max }}
                    label={t('text.character_count', '{count}/{max} characters')}
                    type='tiny'
                    weight='regular'
                />
            );
        } else {
            return (
                <UtilityText
                    color={colors.colorTextHint}
                    formatParams={{ count, max }}
                    label={t('text.character_count', '{count}/{max} characters')}
                    type='tiny'
                    weight='regular'
                />
            );
        }
    }

    if (count === 0) {
        return (
            <UtilityText
                color={colors.colorTextHint}
                formatParams={{ min }}
                label={t('text.character_count_min', '{min} characters min')}
                type='tiny'
                weight='regular'
            />
        );
    } else if (count < min) {
        return (
            <UtilityText
                color={colors.colorTextHint}
                formatParams={{ count, min }}
                label={t('text.character_count_progress_min', '{count}/{min} characters min')}
                type='tiny'
                weight='regular'
            />
        );
    } else if (count > max) {
        return (
            <UtilityText
                color={colors.colorTextWarning}
                formatParams={{ count, max }}
                label={t('text.character_count_over_max', '{count}/{max} characters max')}
                type='tiny'
                weight='regular'
            />
        );
    } else {
        return (
            <HorizBox>
                <Checkmark color={colors.colorTextPrimary} />
                <Pad size={8} />
                <UtilityText
                    formatParams={{ count, max }}
                    label={t('text.character_count_max', '{count}/{max} characters max')}
                    type='tiny'
                    weight='regular'
                />
            </HorizBox>
        );
    }
}
